<template>
	<div>
		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
        <div class="alert" v-if="status > 200">
            <span v-if="status == 401">
              {{ t.error.access_denied_content }}
            </span>
            <span v-if="status == 404">
              {{ t.error.notfound_content_list }}
            </span>

          <filterGenerator :filter="filter"></filterGenerator>
        </div>
        <div class="support-index" v-if="status == 200">
          <div class="support-tickets">
            <div class="support-tickets-header">
              <div class="tickets-control">
                <h5>{{ t.navigation.orders }}</h5>
              </div>
              <div class="tickets-filter">

              </div>
            </div>
            <div class="support-ticket" v-on:click="setUser(row.user.id)" v-for="row in transactions">
              <router-link v-tooltip="t.order_manage" :to="{ name: 'orders', query: $route.query, params: {id: row.id} }">
                <div class="st-meta">
                  <template v-if="row.status == 'Pending' || row.status == 'PendingApproval' ">
                    <span class="status-pill blue smaller"></span><span>{{ t.transactions.status.pending }}</span>
                  </template>
                  <template v-if="row.status == 'Processed'">
                    <span class="status-pill yellow smaller"></span><span>{{ t.transactions.status.processed }}</span>
                  </template>
                  <template v-if="row.status == 'Faıled'">
                    <span class="status-pill red smaller"></span><span>{{ t.transactions.status.failed }}</span>
                  </template>
                  <template v-if="row.status == 'Cancelled'">
                    <span class="status-pill red smaller"></span><span>{{ t.transactions.status.cancelled }}</span>
                  </template>
                </div>
                <div class="st-body">
                  <div class="avatar"><img alt="" :src="api+'api/v1/users/get/profile_pic/'+row.id"></div>
                  <div class="ticket-content">
                    <h6 class="ticket-title">{{ row.amount | toMoney(row.currency) }}</h6>
                    <div class="ticket-description">{{row.info}} #{{ row.id }}</div>
                  </div>
                </div>
              </router-link>
              <div class="st-foot"><span class="label">Client:</span>
                <router-link class="value with-avatar" :to="{name: 'userprofile', params: {id: row.user.id}}">
                  <img alt="" src="img/avatar1.jpg"><span>{{row.user.name}}</span>
                </router-link>
                  <span class="label">Added:</span><span class="value">{{ dateTimeFormat(row.addedAt) }}</span>
              </div>
            </div>
          </div>
          <div class="support-ticket-content-w">
            <div class="support-ticket-content">
              <div class="support-ticket-content-header">
                <h3>#{{ $route.params.id }}</h3>
              </div>
              <div class="ticket-thread">
                <transactionDetail :id.sync="$route.params.id" v-if="$route.params.id" />
              </div>
            </div>
            <div class="support-ticket-info">
              <userTicketWidget :id="uid" />
              <div class="info-section">
                <filterGenerator :filter="filter"></filterGenerator>
              </div>
            </div>
          </div>
        </div>


				<div class="row pt-4">
					<div class="col-sm-12">
							<div class="element-box-tp">
								<div class="mobile-content" v-if="w < 700">
									<div class="element-box relative" v-for="row in transactions">

										<div class="row p-0">
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														#
													</span>
													{{ row.id }}
												</div>
											</div>
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														{{ t.amount }}
													</span>
													{{ row.amount | toMoney(row.currency) }}
												</div>
											</div>
											<div class="col-6 p-0">
												<div class="listy b-b">
													<span class="label">
														{{ t.transaction }}
													</span>
													{{ row.info }}
												</div>
											</div>
											<div class="col-6 p-0">
                      <div class="listy b-b">
													<span class="label">
														{{ t.created_at }}
													</span>
                        {{ dateTimeFormat(row.addedAt) }}
                      </div>
                    </div>
										</div>
									</div>

								</div>

								<paginate v-if="pagination"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>
							</div>
						</div>
						<!--END - User List -->
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

    import userTicketWidget from '@/components/user/widget/supportTicketWidget'
	  import transactionDetail from '@/components/accounting/transactionDetail'
    import filterGenerator from '@/components/form/filter'
    import { TableComponent, TableColumn } from 'vue-table-component'
    export default {
        name: 'transaction',
        components: { 'table-component': TableComponent, 'table-column': TableColumn, filterGenerator, transactionDetail,
            userTicketWidget },
        data () {
            return {
                api: window.api,
                w: window.innerWidth,
                isLoading: false,
                transactions: null,
                pagination: null,
                t: this.$root.t,
                status: 0,
                types: null,
                promotions: null,
                paymentMethods: null,
                filter: {},
                uid: null
            }
        },
        watch: {
            '$route.query' () {
                this.fetchTransactions();
            },
            '$route.params.id' () {
                if (this.$route.params.id > 0) {
                    //this.openModal();
                }
            }
        },
        close () {
            clearInterval(this.refreshInterval);
        },
        mounted () {
            this.$route.params.id = 0;
            this.fetchCurrencies();
            this.fetchTypies();
            this.filterFixture();
            this.fetchTransactions();
            this.fetchPromotions();
            this.fetchPaymentMethods();

            if (this.$route.params.id > 0) {
                this.openModal();
            }

             this.refreshInterval = setInterval(this.fetchTransactions, 40000);
        },
        methods: {
            closeModal () {
                this.$router.push({query: this.$route.query, params: {id: 0}});

                setTimeout(() => {
                document.body.style.overflow='auto';
                }, 500);
            },
            openModal () {
                this.$refs.umodal.open();


            },
            fiterNow () {
                this.$router.push({ query: this.filter.model });
            },
            setUser (id) {
                this.uid = id;
            },
            onChangePage (page) {
                this.pagination.current = page;

                this.$route.query.page = page;
                var qr = this.$route.query;
                this.$router.push({});

                this.$router.push({ query: qr });

                this.filter.model.page = page;

                window.scroll(0, 0);
            },
            fetchTransactions () {

                if(!this.transactions){
                    this.isLoading = true;
                }

                this.$http.get(api+'api/v1/user/transactions?onlyOrder=1&noCache=1&per_page=10&short=t.id&direction=DESC', {params: this.$route.query }).then(response => {
                    // get body data
                    this.transactions = response.body.result.transactions;
                    this.pagination = response.body.result.pagination;
                    this.isLoading = false;
                    this.status = response.status;

                }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            },
            filterFixture () {
                this.filter = {
                    model: {
                        id: null,
                        page: 1,
                        uid: '',
                        username: '',
                        currencies: [],
                        type: [],
                        promotions: [],
                        rangeDateTime: '',
                        rangeAmount: {},
	                      payments: []
                    },
                    schema: {
                        groups: [
                            {
                                legend: 'Filter',
                                fields: [
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: 'ID',
                                        model: "id",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.user.id,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "User",
                                        label: this.t.user.username,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "AmountRange",
                                        label: this.t.amount_range,
                                        model: "rangeAmount",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.created_at,
                                        model: "rangeDateTime",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.payment_methods,
                                        model: "payments",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.paymentMethods,
                                        checklistOptions: {
                                            value: "id",
                                            name: "name"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.transaction,
                                        model: "type",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.types,
                                        checklistOptions: {
                                            value: "id",
                                            name: "info"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.finance.currency,
                                        model: "currencies",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.currencies,
                                        checklistOptions: {
                                            value: "id",
                                            name: "iso_code"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.promotions,
                                        model: "promotions",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.promotions,
                                        checklistOptions: {
                                            value: "id",
                                            name: "title"
                                        }
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.filter.title,
                                        onSubmit: this.fiterNow,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            },
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },

            async fetchCurrencies () {
              this.$http.get(api+'api/v1/currencies')
                  .then(response => {

                    this.currencies = response.body.result.currencies;
                        this.filterFixture();
                    }, response => {

                })
                },
                async fetchTypies () {
                    this.$http.get(api+'api/v1/user/transactions/types')
                        .then(response => {

                        this.types = response.body.result;
                        this.filterFixture();
                }, response => {

                    })
                },
                async fetchPaymentMethods () {
                    this.$http.get(api+'api/v1/payment/methods').then(response => {
                        // get body data
                        this.paymentMethods = response.body.result.payments;
                        this.filterFixture();

                        }, response => {
                    })
                },
                async fetchPromotions () {
                    this.$http.get(api+'api/v1/promotions?noCache=1').then(response => {
                        // get body data
                        this.promotions = response.body.promotions;
                        this.filterFixture();

                }, response => {
                    })
                },
          }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/orders.vue